<template>
	<v-row class="row_" dense>
		<v-col cols="auto">
			<v-alert
					class="alert_"
					color="error"
					dense
					text>
				<span	class="overline"
						v-text="firebaseState_.firestore.read" />
			</v-alert>
		</v-col>
		<v-col cols="auto">
			<v-alert
					class="alert_"
					color="error"
					dense
					text>
				<span	class="overline"
						v-text="firebaseState_.firestore.write" />
			</v-alert>
		</v-col>
		<v-col cols="auto">
			<v-alert
					class="alert_"
					color="error"
					dense
					text>
				<span	class="overline"
						v-text="firebaseState_.functions.call" />
			</v-alert>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'DebuggerFirebaseAlert',
		data() {
			return {
				firebaseState_: {}
			}
		},
		beforeMount() {
			const self_ = this;
			
			const app_ = self_.getState('app')
			self_.firebaseState_ = app_.firebase;
		}
	}
</script>

<style scoped>
	.row_ {
		flex-grow: 0;
	}
	.alert_ {
		margin-bottom: 0;
	}
</style>
